import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

const DEFAULT_SOURCE_FIELDS = ['firstName', 'lastName', 'email', 'mobile', 'companyName', 'email2', 'email3', 'phone2'];

export const DEFAULT_SOURCE_FIELD_LABELS: Record<string, string> = {
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'Personal Email',
  mobile: 'Mobile Phone',
  companyName: 'Current Company',
  email2: 'Work Email',
  email3: 'Email 3',
  phone2: 'phone2'
};

@Injectable({ providedIn: 'root' })
export class EnrichmentSourceFieldsService {

  constructor(private http: HttpClient) {}

  getAvailableFields(): Observable<{ fieldName: string; fieldLabel: string }[]> {
    return this.http.get<any[]>(`${environment.duplikitUrl}/meta/getAvailableBHFields?entity=candidate`);
  }

  getSourceFields(): Observable<string[]> {
    return this.http.get<string[]>(`${environment.dataRulesUrl}/enrichment/getSourceFields`).pipe(
      map(fields => fields.length > 0 ? fields : [...DEFAULT_SOURCE_FIELDS]),
      catchError(() => of([...DEFAULT_SOURCE_FIELDS]))
    );
  }

  saveSourceFields(fields: string[]): Observable<any> {
    return this.http.post(`${environment.dataRulesUrl}/enrichment/saveSourceFields`, { fields });
  }
}
